import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";
import { canDeactivateGuard } from "src/app/core/guards/can-deactivate.guard";

export const ProductsRoutes: Routes = [
  {
    path: "catalogue",
    loadComponent: () =>
      import("./products/products.component").then((m) => m.ProductsComponent),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./products-list/products-list.component").then(
            (m) => m.ProductsListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./products-form/products-form.component").then(
            (m) => m.ProductsFormComponent,
          ),
      },
      {
        path: "view/:id",
        loadComponent: () =>
          import("./products-form/products-form.component").then(
            (m) => m.ProductsFormComponent,
          ),
        canDeactivate: [canDeactivateGuard],
      },
      {
        path: "view/:id/redemption-partner/:partnerId",
        loadComponent: () =>
          import("./redemption-partner/redemption-partner-form/redemption-partner-form.component").then(
            (m) => m.RedemptionPartnerFormComponent,
          ),
      },
    ],
  },
];
